var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-xl-12"},[_c('system-panel',{attrs:{"data":_vm.data.dataInside,"text":"Thông tin nội bộ"}}),_c('system-panel',{attrs:{"data":_vm.data.dataReport,"text":"Hệ thống báo cáo"}}),_c('system-panel',{attrs:{"data":_vm.data.dataOperate,"text":"Vận hành doanh nghiệp"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }